import React, { useState, useEffect } from 'react';
import { Carousel as ResponsiveCarousel } from 'react-responsive-carousel';

import 'react-responsive-carousel/lib/styles/carousel.min.css';
import './index.css';

const MOBILE_SLIDE_WIDTH_PERCENT = 46;
const DESKTOP_SLIDE_WIDTH_PERCENT = 39.5;
const MOBILE_WIDTH_BREAKPOINT = 448;

const getCenterSlideWidthPercent = (width) => {
  if (width <= MOBILE_WIDTH_BREAKPOINT) {
    return MOBILE_SLIDE_WIDTH_PERCENT;
  }

  return DESKTOP_SLIDE_WIDTH_PERCENT;
}

const Carousel = ({ children }) => {
  const [centerSlideWidth, setCenterSlideWidth] = useState(getCenterSlideWidthPercent(window && window.innerWidth));

  const handleResize = () => {
    const width = getCenterSlideWidthPercent(window && window.innerWidth) || DESKTOP_SLIDE_WIDTH_PERCENT;
    setCenterSlideWidth(width);
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <ResponsiveCarousel
      showIndicators={false}
      showThumbs={false}
      showStatus={false}
      showArrows={false}
      centerSlidePercentage={centerSlideWidth}
      centerMode
      autoPlay
      infiniteLoop
    >
      {children}
    </ResponsiveCarousel>
  );
};

export default Carousel;